import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useFlightTypeContext } from 'src/contexts/flight-type.context';
import { actionTypes } from 'src/ducks/flight-type.duck';
import { IFlightType } from 'src/models/flight-type.model';
import Lang from 'src/libraries/language';
import { getFlightTypeStatus } from 'src/selectors/flight-type.selector';
import style from '../flight-types-list/flight-types-list.module.scss';

type IProp = {
  data: IFlightType;
};

const FlightTypeDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useFlightTypeContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getFlightTypeStatus(
    state,
    actionTypes.FLIGHT_TYPE_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.flightTypeId) {
      const response = await actions.itemDELETE(data.flightTypeId);

      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(
            Lang.MSG_FLIGHT_TYPE_DELETE_SUCCESS,
            data.flightType
          )
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_FLIGHT_TYPE}
      content={
        <div className={style.content}>
          {Lang.formatString(Lang.MSG_CONFIRM_DELETE, data.flightType)}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default FlightTypeDelete;
